// extracted by mini-css-extract-plugin
module.exports = {"strokeMarketplaceColor":"IconKeys_strokeMarketplaceColor__3YQsi"};